export default __webpack_public_path__ + "static/media/mobile-guru-parampara.700e8bf5.png";